import calendarService, { IDay } from '@/services/calendar/calendar.service';
import { Box, Text } from '@chakra-ui/react';
import { DateTime } from 'luxon';
import { ICalendarEvent } from '../../../../TCalendar';

interface IProps {
	day: IDay;
	event: ICalendarEvent;
	onEventClick: (event: ICalendarEvent) => void;
	locale: string;
	timeZone: string;
}

const MARGIN_SIZE = .5;

export default function CalendarEvent(props: IProps) {
	const calendarEvent = structuredClone(props.event);

	calendarEvent.start = DateTime.fromISO(props.event.start.toISO()!, { zone: props.timeZone });
	calendarEvent.end = DateTime.fromISO(props.event.end.toISO()!, { zone: props.timeZone });

	const isStartingInDay = props.day.dt.hasSame(calendarEvent.start, 'day');
	const isEndingInDay = props.day.dt.hasSame(calendarEvent.end, 'day');

	function handleEventClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
		props.onEventClick(calendarEvent);
	}

	return (
		<Box
			zIndex={2}
			alignItems="center"
			bg={calendarEvent.color + '.200'}
			borderLeftColor={calendarEvent.color + '.600'}
			borderLeftWidth={isStartingInDay ? 3 : 0}
			borderRightColor={calendarEvent.color + '.600'}
			borderRightWidth={isEndingInDay ? 3 : 0}
			_hover={{
				bg: calendarEvent.color + '.300',
			}}
			// color="white"
			cursor="pointer"
			display="grid"
			fontSize="x-small"
			gridColumnEnd={2}
			gridColumnStart={1}
			gridRowEnd={calendarEvent.row! + 1}
			gridRowStart={calendarEvent.row}
			gridTemplateColumns="auto 1fr"
			ml={isStartingInDay ? MARGIN_SIZE : 0}
			mr={isEndingInDay ? MARGIN_SIZE : 0}
			my="0.5px"
			onClick={handleEventClick}
			onMouseDown={(e) => {
				e.stopPropagation();
			}}
			onMouseUp={(e) => {
				e.stopPropagation();
			}}
			overflow="hidden"
			py={1}
			whiteSpace="nowrap"
			borderStartRadius={isStartingInDay ? 'sm' : 0}
			borderEndRadius={isEndingInDay ? 'sm' : 0}
		>
			<Text px={1} fontFamily="mono" fontWeight={900}>
				{isStartingInDay && !props.event.uiHideHour
					? calendarService.formatDate({
							date: calendarEvent.start.toJSDate(),
							locale: props.locale,
							options: { hour: '2-digit', minute: '2-digit' },
					  })
					: ''}
			</Text>

			<Text ml={1} mr={0} overflow="hidden" textOverflow="ellipsis" fontWeight={400}>
				{isStartingInDay ? calendarEvent.title : ''}
			</Text>
		</Box>
	);
}
